import React from "react";
import { useTranslation } from "react-i18next";
import { ContractStatus } from "../enums/contractStatus";

interface Props {
  status: ContractStatus;
  className?: string;
  asText?: boolean;
}

const ContractStatusLabel = ({ status, className, asText = false }: Props) => {
  const { t } = useTranslation(["contracts\\enums\\contractStatus"]);

  const getStatusClass = (
    status: ContractStatus,
    asText: boolean,
    className?: string
  ) => {
    let colorClass = "";
    switch (status) {
      case ContractStatus.Draft:
        colorClass = "info";
        break;
      case ContractStatus.Valid:
        colorClass = "warning";
        break;
      case ContractStatus.Effective:
        colorClass = "success";
        break;
      case ContractStatus.Terminated:
      case ContractStatus.Canceled:
        colorClass = "danger";
        break;
      default:
        colorClass = "";
    }

    const baseClasses = "small font-weight-normal";
    const contextClass = asText
      ? (colorClass ? `text-${colorClass}` : "")
      : (colorClass ? `badge badge-pill badge-${colorClass}` : "badge");
    return `${baseClasses} ${contextClass}${className ? ` ${className}` : ""}`;
  };

  return (
    <span className={getStatusClass(status, asText, className)}>
      {t(status)}
    </span>
  );
};

export default ContractStatusLabel;
